import { FC } from 'react'
import BackgroundBox, { BackgroundBoxHeightType } from '../../BackgroundBox'

interface MeetingBackground {
  other?: boolean
  withFooter?: boolean
  withHeader?: boolean
  heigth?: BackgroundBoxHeightType
  id?: string
  noShadow?: boolean
}

const MeetingBackground: FC<MeetingBackground> = ({ other, withFooter, withHeader, heigth, id, noShadow, children }) => {
  let radius = false,
    radiusTop = false,
    radiusBottom = false
  let offsetHeight: BackgroundBoxHeightType = 'meetingBasic' // needs default

  if (other) {
    radius = true
    offsetHeight = 'otherMeetings'
  } else if (withFooter && withHeader) {
    offsetHeight = 'meetingWithFooterAndHeader'
  } else if (withFooter) {
    radiusTop = true
    offsetHeight = 'meetingWithFooter'
  } else if (withHeader) {
    offsetHeight = 'meetingWithHeader'
    radiusBottom = true
  } else if (heigth) {
    radiusBottom = true
    offsetHeight = heigth
  } else {
    radius = true
    offsetHeight = 'meetingBasic'
  }

  return (
    <BackgroundBox id={id} r={radius} rt={radiusTop} rb={radiusBottom} height={offsetHeight} noShadow={noShadow}>
      {children}
    </BackgroundBox>
  )
}
export default MeetingBackground
